import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import {
  Grid, Segment, Divider, Form,
  Checkbox, Pagination, Accordion, Icon
} from "semantic-ui-react";
import Chart from "react-apexcharts";
import ApexChart from "apexcharts";
import Constants from "./utilities/Constants";
import Strings from "./utilities/StringSelector";
import Utils from "./utilities/Utils";

const UtilsInstance = new Utils();

class BarGraph extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isAmplitudeCheckboxChecked: false,

      activeChart: "",

      isAddrCheckboxActive: true,
      isDescCheckboxActive: false,
      isAscCheckboxActive: false,

      amplitudeSeries: [],
      minAmplitudeSeries: [],

      activePage: 1,
      numOfPages: 1,

      ascAddrcAmplitudePageMap: new Map(),     // Ordered by address ascending
      ascAmplitudePageMap: new Map(),          // Ordered by amplitude ascending
      descAmplitudePageMap: new Map(),         // Ordered by amplitude descending

      ascAddrcMinAmplitudePageMap: new Map(),  // Ordered by address ascending
      ascMinAmplitudePageMap: new Map(),        // Ordered by min amplitude ascending        
      descMinAmplitudePageMap: new Map(),      // Ordered by min amplitude descending

      options: {
        tooltip: {
          enabled: false,
          x: {
            show: true,
            formatter: function (val) {
              return Strings.ADDRESS + ": " + val;
            },
          },
          marker: {
            show: false,
          },
        },
        chart: {
          id: Constants.BAR_GRAPH_CHART_ID,
          animations: {
            enabled: false
          },
          toolbar: {
            tools: {
              download: false
            }
          },
          locales: [{
            "name": "pt-br",
            "options": {
              "toolbar": {
                "exportToSVG": "Baixar SVG",
                "exportToPNG": "Baixar PNG",
                "exportToCSV": "Baixar CSV",
                "menu": "Baixar"
              }
            }
          }],
          defaultLocale: "pt-br",
        },
        title: {
          text: Strings.MIN_AMPLITUDE,
          align: "center"
        },
        xaxis: {
          type: "category",
          title: {
            text: Strings.ADDRESS
          },
          crosshairs: {
            show: "true"
          }
        },
        yaxis: {
          min: 0,
          max: 12,
          tickAmount: 12,
          labels: {
            formatter: function (val) {
              return val.toFixed(2) + Strings.VOLTAGE_PEAK_TO_PEAK;
            },
          },
          title: {
            text: Strings.VOLTAGE_V_PEAK_TO_PEAK
          },
        },
        colors: [function ({ value }) {
          return (UtilsInstance.getBarGraphColorBasedOnValue(value, Constants));
        }],
        plotOptions: {
          bar: {
            dataLabels: {
              position: "top",
            }
          }
        },
        dataLabels: {
          formatter: function (val) {
            if (val < 0) {
              // Don't show the number above a bar with
              // negative values
              return "";
            }
            else if (val === 0) {
              return "0,00";
            }
            else {
              return val;
            }
          },
          style: {
            fontSize: "14px",
            fontFamily: "Helvetica, Arial, sans-serif",
            fontWeight: 400,
            colors: ["#212121"],
          },
          offsetY: -22,
        }
      },

      errorMessages: [],
      // Controller para cancelar requests caso saia da tela
      controller: new AbortController()
    };
  }

  retrieveData = () => {
    fetch(Constants.REQUEST_IP_ADDRESS, { mode: "cors", signal: this.state.controller.signal })
      .then(res => res.json())
      .then(data =>
        this.setState({ devices: data }, () => {
          // Set the state of the number of pages, it will be used for everything else
          this.setState({ numOfPages: Math.ceil(this.state.devices.length / Constants.MAX_DEV_PER_PAGE) }, () => {
            // Save the mappings
            this.setState({
              ascAddrcAmplitudePageMap: this.createAscAddrAmpPageMap(),
              ascAmplitudePageMap: this.createAscAmpPageMap(),
              descAmplitudePageMap: this.createDescAmpPageMap(),

              ascAddrcMinAmplitudePageMap: this.createAscAddrMinAmpPageMap(),
              ascMinAmplitudePageMap: this.createAscMinAmpPageMap(),
              descMinAmplitudePageMap: this.createDescMinAmpPageMap()
            }, () => {
              this.showAmpGraph();
            });
          });
        })
      )
      .catch((e) => {
        console.log("Request interrupted: ", e);
      });
  }

  /// ---------------- Mappings ----------------
  createAscAddrAmpPageMap = () => {
    let ascAddrAmpMap = new Map();

    let ascAddrSortedDevices = this.state.devices.sort(
      UtilsInstance.sortBy(
        "address",
        false,
        parseInt)
    );

    for (let i = 0; i < this.state.numOfPages; i++) {
      let devicesSlice = [];

      if (i === (this.state.numOfPages - 1)) {
        devicesSlice = ascAddrSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, ascAddrSortedDevices.length);
      }
      else {
        devicesSlice = ascAddrSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, (i + 1) * Constants.MAX_DEV_PER_PAGE);
      }

      let ampPageSeries = [];

      for (let j = 0; j < devicesSlice.length; j++) {
        ampPageSeries.push({
          x: devicesSlice[j].address.toString(),
          y: UtilsInstance.getFormatedAmplitudeForFaded(
            devicesSlice[j].amplitude,
            devicesSlice[j].hasWaveProblem)
        });
      }

      // Complete the last slice with fake data, until it has exactly 15
      // bars to show on the screen
      if (i === (this.state.numOfPages - 1)) {
        let remainingDevices = Constants.MAX_DEV_PER_PAGE - ampPageSeries.length;

        if (remainingDevices > 0) {
          for (let j = 0; j < remainingDevices; j++) {
            ampPageSeries.push({ x: "", y: -1 });
          }
        }

      }

      ascAddrAmpMap.set(i, ampPageSeries);
    }

    return ascAddrAmpMap;
  }

  createAscAddrMinAmpPageMap = () => {
    let ascAddrMinAmpMap = new Map();

    let ascAddrSortedDevices = this.state.devices.sort(
      UtilsInstance.sortBy(
        "address",
        false,
        parseInt)
    );

    for (let i = 0; i < this.state.numOfPages; i++) {
      let devicesSlice = [];

      if (i === (this.state.numOfPages - 1)) {
        devicesSlice = ascAddrSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, ascAddrSortedDevices.length);
      }
      else {
        devicesSlice = ascAddrSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, (i + 1) * Constants.MAX_DEV_PER_PAGE);
      }

      let minAmpPageSeries = [];

      for (let j = 0; j < devicesSlice.length; j++) {
        minAmpPageSeries.push({
          x: devicesSlice[j].address.toString(),
          y: UtilsInstance.getFormatedAmplitudeForFaded(
            devicesSlice[j].amplitudeMin,
            devicesSlice[j].hasWaveProblem)
        });
      }

      // Complete the last slice with fake data, until it has exactly 15
      // bars to show on the screen
      if (i === (this.state.numOfPages - 1)) {
        let remainingDevices = Constants.MAX_DEV_PER_PAGE - minAmpPageSeries.length;

        if (remainingDevices > 0) {
          for (let j = 0; j < remainingDevices; j++) {
            minAmpPageSeries.push({ x: "", y: -1 });
          }
        }

      }

      ascAddrMinAmpMap.set(i, minAmpPageSeries);
    }

    return ascAddrMinAmpMap;
  }

  createAscAmpPageMap = () => {
    let ascAmpMap = new Map();

    let ascAmpSortedDevices = this.state.devices.sort(
      UtilsInstance.sortBy(
        "amplitude",
        false,
        parseFloat)
    );

    for (let i = 0; i < this.state.numOfPages; i++) {
      let devicesSlice = [];

      if (i === (this.state.numOfPages - 1)) {
        devicesSlice = ascAmpSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, ascAmpSortedDevices.length);
      }
      else {
        devicesSlice = ascAmpSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, (i + 1) * Constants.MAX_DEV_PER_PAGE);
      }

      let ampPageSeries = [];

      for (let j = 0; j < devicesSlice.length; j++) {
        ampPageSeries.push({
          x: devicesSlice[j].address.toString(),
          y: UtilsInstance.getFormatedAmplitudeForFaded(
            devicesSlice[j].amplitude,
            devicesSlice[j].hasWaveProblem)
        });
      }

      // Complete the last slice with fake data, until it has exactly 15
      // bars to show on the screen
      if (i === (this.state.numOfPages - 1)) {
        let remainingDevices = Constants.MAX_DEV_PER_PAGE - ampPageSeries.length;

        if (remainingDevices > 0) {
          for (let j = 0; j < remainingDevices; j++) {
            ampPageSeries.push({ x: "", y: -1 });
          }
        }

      }

      ascAmpMap.set(i, ampPageSeries);
    }

    return ascAmpMap;
  }

  createDescAmpPageMap = () => {
    let descAmpMap = new Map();

    let descAmpSortedDevices = this.state.devices.sort(
      UtilsInstance.sortBy(
        "amplitude",
        true,
        parseFloat)
    );

    for (let i = 0; i < this.state.numOfPages; i++) {
      let devicesSlice = [];

      if (i === (this.state.numOfPages - 1)) {
        devicesSlice = descAmpSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, descAmpSortedDevices.length);
      }
      else {
        devicesSlice = descAmpSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, (i + 1) * Constants.MAX_DEV_PER_PAGE);
      }

      let ampPageSeries = [];

      for (let j = 0; j < devicesSlice.length; j++) {
        ampPageSeries.push({
          x: devicesSlice[j].address.toString(),
          y: UtilsInstance.getFormatedAmplitudeForFaded(
            devicesSlice[j].amplitude,
            devicesSlice[j].hasWaveProblem)
        });
      }

      // Complete the last slice with fake data, until it has exactly 15
      // bars to show on the screen
      if (i === (this.state.numOfPages - 1)) {
        let remainingDevices = Constants.MAX_DEV_PER_PAGE - ampPageSeries.length;

        if (remainingDevices > 0) {
          for (let j = 0; j < remainingDevices; j++) {
            ampPageSeries.push({ x: "", y: -1 });
          }
        }

      }

      descAmpMap.set(i, ampPageSeries);
    }

    return descAmpMap;
  }

  createAscMinAmpPageMap = () => {
    let ascMinAmpMap = new Map();

    let ascMinAmpSortedDevices = this.state.devices.sort(
      UtilsInstance.sortBy(
        "amplitudeMin",
        false,
        parseFloat)
    );

    for (let i = 0; i < this.state.numOfPages; i++) {
      let devicesSlice = [];

      if (i === (this.state.numOfPages - 1)) {
        devicesSlice = ascMinAmpSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, ascMinAmpSortedDevices.length);
      }
      else {
        devicesSlice = ascMinAmpSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, (i + 1) * Constants.MAX_DEV_PER_PAGE);
      }

      let minAmpPageSeries = [];

      for (let j = 0; j < devicesSlice.length; j++) {
        minAmpPageSeries.push({
          x: devicesSlice[j].address.toString(),
          y: UtilsInstance.getFormatedAmplitudeForFaded(
            devicesSlice[j].amplitudeMin,
            devicesSlice[j].hasWaveProblem)
        });
      }

      // Complete the last slice with fake data, until it has exactly 15
      // bars to show on the screen
      if (i === (this.state.numOfPages - 1)) {
        let remainingDevices = Constants.MAX_DEV_PER_PAGE - minAmpPageSeries.length;

        if (remainingDevices > 0) {
          for (let j = 0; j < remainingDevices; j++) {
            minAmpPageSeries.push({ x: "", y: -1 });
          }
        }

      }

      ascMinAmpMap.set(i, minAmpPageSeries);
    }

    return ascMinAmpMap;
  }

  createDescMinAmpPageMap = () => {
    let descMinAmpMap = new Map();

    let descMinAmpSortedDevices = this.state.devices.sort(
      UtilsInstance.sortBy(
        "amplitudeMin",
        true,
        parseFloat)
    );

    for (let i = 0; i < this.state.numOfPages; i++) {
      let devicesSlice = [];

      if (i === (this.state.numOfPages - 1)) {
        devicesSlice = descMinAmpSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, descMinAmpSortedDevices.length);
      }
      else {
        devicesSlice = descMinAmpSortedDevices.slice(i * Constants.MAX_DEV_PER_PAGE, (i + 1) * Constants.MAX_DEV_PER_PAGE);
      }

      let minAmpPageSeries = [];

      for (let j = 0; j < devicesSlice.length; j++) {
        minAmpPageSeries.push({
          x: devicesSlice[j].address.toString(),
          y: UtilsInstance.getFormatedAmplitudeForFaded(
            devicesSlice[j].amplitudeMin,
            devicesSlice[j].hasWaveProblem)
        });
      }

      // Complete the last slice with fake data, until it has exactly 15
      // bars to show on the screen
      if (i === (this.state.numOfPages - 1)) {
        let remainingDevices = Constants.MAX_DEV_PER_PAGE - minAmpPageSeries.length;

        if (remainingDevices > 0) {
          for (let j = 0; j < remainingDevices; j++) {
            minAmpPageSeries.push({ x: "", y: -1 });
          }
        }

      }

      descMinAmpMap.set(i, minAmpPageSeries);
    }

    return descMinAmpMap;
  }

  /// ---------------- Graph Type Options ----------------
  onGraphTypeCheckboxChange = (e, { value }) => {
    this.setState({ isAmplitudeCheckboxChecked: (value === Constants.AMPLITUDE_ID) }, () => {
      // Show the pagination
      document.getElementById("pagination").style.visibility = "visible";

      if (value === Constants.AMPLITUDE_ID) {
        if (this.state.isAddrCheckboxActive) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.MEAN_AMPLITUDE,
            data: this.state.ascAddrcAmplitudePageMap.get(this.state.activePage - 1)
          }]);
        }
        else if (this.state.isAscCheckboxActive) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.MEAN_AMPLITUDE,
            data: this.state.ascAmplitudePageMap.get(this.state.activePage - 1)
          }]);
        }
        else if (this.state.isDescCheckboxActive) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.MEAN_AMPLITUDE,
            data: this.state.descAmplitudePageMap.get(this.state.activePage - 1)
          }]);
        }

        // Change the title of the chart
        ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateOptions", {
          title: {
            text: Strings.MEAN_AMPLITUDE,
            align: "center"
          }
        });

        // And save that this is the active chart now
        this.setState({ activeChart: Constants.AMPLITUDE_ID });
      }
      else if (value === Constants.MIN_AMPLITUDE_ID) {

        if (this.state.isAddrCheckboxActive) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.MIN_AMPLITUDE,
            data: this.state.ascAddrcMinAmplitudePageMap.get(this.state.activePage - 1)
          }]);
        }
        else if (this.state.isAscCheckboxActive) {
          // Order by y value depending on the ordering selected by the user
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.MIN_AMPLITUDE,
            data: this.state.ascMinAmplitudePageMap.get(this.state.activePage - 1)
          }]);
        }
        else if (this.state.isDescCheckboxActive) {
          // Order by y value depending on the ordering selected by the user
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.MIN_AMPLITUDE,
            data: this.state.descMinAmplitudePageMap.get(this.state.activePage - 1)
          }]);
        }

        // Change the title of the chart
        ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateOptions", {
          title: {
            text: Strings.MIN_AMPLITUDE,
            align: "center"
          }
        });

        // And save that this is the active chart now
        this.setState({ activeChart: Constants.MIN_AMPLITUDE_ID });
      }

      // Now that the user has selected one of the charts
      // allow the controls to be used
      this.setChartControlsDisabledState(false, false, false);
    });
  }

  showAmpGraph = () => {
    // Show the pagination
    document.getElementById("pagination").style.visibility = "visible";

    // IF THE ORDER BY ADDRESS CHECKBOX IS MARKED
    if (this.state.isAddrCheckboxActive) {
      if (this.state.isAmplitudeCheckboxChecked) {
        ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
          name: Strings.MEAN_AMPLITUDE,
          data: this.state.ascAddrcAmplitudePageMap.get(this.state.activePage - 1)
        }]);
      }
      else {
        ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
          name: Strings.MIN_AMPLITUDE,
          data: this.state.ascAddrcMinAmplitudePageMap.get(this.state.activePage - 1)
        }]);
      }
    }
    // IF THE ORDER BY AMPLITUDE ASCENDING CHECKBOX IS MARKED
    else if (this.state.isAscCheckboxActive) {
      if (this.state.isAmplitudeCheckboxChecked) {
        ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
          name: Strings.MEAN_AMPLITUDE,
          data: this.state.ascAmplitudePageMap.get(this.state.activePage - 1)
        }]);
      }
      else {
        ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
          name: Strings.MIN_AMPLITUDE,
          data: this.state.ascMinAmplitudePageMap.get(this.state.activePage - 1)
        }]);
      }
    }
    // IF THE ORDER BY AMPLITUDE DESCENDING CHECKBOX IS MARKED
    else if (this.state.isDescCheckboxActive) {
      if (this.state.isAmplitudeCheckboxChecked) {
        ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
          name: Strings.MEAN_AMPLITUDE,
          data: this.state.descAmplitudePageMap.get(this.state.activePage - 1)
        }]);
      }
      else {
        ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
          name: Strings.MIN_AMPLITUDE,
          data: this.state.descMinAmplitudePageMap.get(this.state.activePage - 1)
        }]);
      }
    }

    // Change the title of the chart
    if (this.state.isAmplitudeCheckboxChecked) {
      ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateOptions", {
        title: {
          text: Strings.MEAN_AMPLITUDE,
          align: "center"
        }
      });
    }
    else {
      ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateOptions", {
        title: {
          text: Strings.MIN_AMPLITUDE,
          align: "center"
        }
      });
    }

    // And save that this is the active chart now
    if (this.state.isAmplitudeCheckboxChecked) {
      this.setState({ activeChart: Constants.AMPLITUDE_ID });
    }
    else {
      this.setState({ activeChart: Constants.MIN_AMPLITUDE_ID });
    }

    // Now that the user has selected one of the charts
    // allow the controls to be used
    this.setChartControlsDisabledState(false, false, false);
  }

  // ---------------- Buttons and Checkboxes active state ----------------
  setChartControlsDisabledState = (ampAddrCheckboxState, ampAscCheckboxState, ampDescCheckboxState) => {
    document.getElementById("amp-addr-checkbox").disabled = ampAddrCheckboxState;
    document.getElementById("amp-asc-checkbox").disabled = ampAscCheckboxState;
    document.getElementById("amp-desc-checkbox").disabled = ampDescCheckboxState;
  }

  // ---------------- Handle clicks on the checkboxes ----------------
  handleOrderCheckboxChange = (e, { value }) => {
    if (value === Constants.CHECKBOX_ADDR_VAL) {
      this.setState({
        isAddrCheckboxActive: true,
        isAscCheckboxActive: false,
        isDescCheckboxActive: false,
      }, () => {
        // Order the active chart by address ascending
        if (this.state.activeChart === Constants.AMPLITUDE_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.MEAN_AMPLITUDE,
            data: this.state.ascAddrcAmplitudePageMap.get(this.state.activePage - 1)
          }]);
        }
        else if (this.state.activeChart === Constants.MIN_AMPLITUDE_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.MIN_AMPLITUDE,
            data: this.state.ascAddrcMinAmplitudePageMap.get(this.state.activePage - 1)
          }]);
        }
      });
    }
    else if (value === Constants.CHECKBOX_ASC_VAL) {
      this.setState({
        isAddrCheckboxActive: false,
        isAscCheckboxActive: true,
        isDescCheckboxActive: false,
      }, () => {
        // Order the active chart by amplitude ascending
        if (this.state.activeChart === Constants.AMPLITUDE_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.MEAN_AMPLITUDE,
            data: this.state.ascAmplitudePageMap.get((this.state.activePage - 1))
          }]);
        }
        else if (this.state.activeChart === Constants.MIN_AMPLITUDE_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.MIN_AMPLITUDE,
            data: this.state.ascMinAmplitudePageMap.get((this.state.activePage - 1))
          }]);
        }
      });
    }
    else if (value === Constants.CHECKBOX_DESC_VAL) {
      this.setState({
        isAddrCheckboxActive: false,
        isAscCheckboxActive: false,
        isDescCheckboxActive: true,
      }, () => {
        // Order the active chart by amplitude descending
        if (this.state.activeChart === Constants.AMPLITUDE_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.MEAN_AMPLITUDE,
            data: this.state.descAmplitudePageMap.get((this.state.activePage - 1))
          }]);
        }
        else if (this.state.activeChart === Constants.MIN_AMPLITUDE_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.MIN_AMPLITUDE,
            data: this.state.descMinAmplitudePageMap.get((this.state.activePage - 1))
          }]);
        }
      });
    }
  }

  // ---------------- Pagination ----------------
  handlePageChange = (e, { activePage }) => {
    this.setState({ activePage: activePage }, () => {
      // Check which of the checkboxes are active first
      if (this.state.isAddrCheckboxActive) {
        // Then check which of the charts are active
        if (this.state.activeChart === Constants.AMPLITUDE_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.MEAN_AMPLITUDE,
            data: this.state.ascAddrcAmplitudePageMap.get((this.state.activePage - 1))
          }]);
        }
        else if (this.state.activeChart === Constants.MIN_AMPLITUDE_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.MIN_AMPLITUDE,
            data: this.state.ascAddrcMinAmplitudePageMap.get((this.state.activePage - 1))
          }]);
        }
      }
      else if (this.state.isAscCheckboxActive) {
        // Then check which of the charts are active
        if (this.state.activeChart === Constants.AMPLITUDE_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.MEAN_AMPLITUDE,
            data: this.state.ascAmplitudePageMap.get((this.state.activePage - 1))
          }]);
        }
        else if (this.state.activeChart === Constants.MIN_AMPLITUDE_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.MIN_AMPLITUDE,
            data: this.state.ascMinAmplitudePageMap.get((this.state.activePage - 1))
          }]);
        }
      }
      else if (this.state.isDescCheckboxActive) {
        // Then check which of the charts are active
        if (this.state.activeChart === Constants.AMPLITUDE_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.MEAN_AMPLITUDE,
            data: this.state.descAmplitudePageMap.get((this.state.activePage - 1))
          }]);
        }
        else if (this.state.activeChart === Constants.MIN_AMPLITUDE_ID) {
          ApexChart.exec(Constants.BAR_GRAPH_CHART_ID, "updateSeries", [{
            name: Strings.MIN_AMPLITUDE,
            data: this.state.descMinAmplitudePageMap.get((this.state.activePage - 1))
          }]);
        }
      }
    });
  }

  /// ---------------- Accordion -----------------------------
  handleAccordionClick = (e, titleProps) => {
    const { index } = titleProps;
    const { accordionIndex } = this.state;
    const newIndex = accordionIndex === index ? -1 : index;

    this.setState({ accordionIndex: newIndex });
  };

  /// ---------------- Error Messages -----------------------------
  retrieveWarnings = () => {
    fetch(Constants.REQUEST_IP_ADDRESS + "warnings", { mode: "cors", signal: this.state.controller.signal })
      .then(res => res.json())
      .then(data => {
        this.handleWarningMessages(data);
      })
      .catch((error) => {
        console.log("Warnings interrupted: ", error);
      });
  }

  handleWarningMessages = (errors) => {
    let errorMessages = [];

    if (errors.InitPicoNotFound || errors.invertedAB || errors.mongoOFF || errors.picoNotFound || errors.monitorIPNotFound) {
      // If at least one of the errors above ocurred, unhide the error message's container
      if (document.getElementById("message-list") !== undefined
        && document.getElementById("message-list") !== null) {

        document.getElementById("message-list").style.display = "block";

      }

      if (errors.InitPicoNotFound) {
        errorMessages.push(Strings.INIT_PICO_NOT_FOUND);
      }

      if (errors.invertedAB) {
        errorMessages.push(Strings.INVERTED_AB);
      }

      if (errors.picoNotFound) {
        errorMessages.push(Strings.PICO_NOT_FOUND);
      }

      if (errors.monitorIPNotFound) {
        errorMessages.push(Strings.MONITOR_IP_NOT_FOUND);
      }

      this.setState({ errorMessages: errorMessages });
    }
    else {

      if (document.getElementById("message-list") !== undefined
        && document.getElementById("message-list") !== null) {

        document.getElementById("message-list").style.display = "none";

      }

      if (document.getElementById("repair-button") !== undefined
        && document.getElementById("repair-button") !== null) {

        document.getElementById("repair-button").style.display = "none";

      }

      this.setState({ errorMessages: [] });
    }
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    sessionStorage.removeItem("auth");
    this.retrieveData();
    this.retrieveWarnings();
    this.setState({ warningsIntervalID: setInterval(this.retrieveWarnings, 1000) });
    this.setState({ retrieveDataIntervalID: setInterval(this.retrieveData, 500) });
  }

  componentWillUnmount() {
    this.state.controller.abort();
    clearInterval(this.state.warningsIntervalID);
    clearInterval(this.state.retrieveDataIntervalID);
  }

  render() {

    return (
      <div style={screenStyle}>

        <Grid columns={2} doubling>

          <Grid.Row>

            <Grid.Column width={4}>

              <Segment>
                <Divider horizontal style={dividerStyle}>{Strings.GRAPH}</Divider>
                <Form>

                  <Form.Group widths="equal" style={formStyle}>
                    <Form.Checkbox
                      radio
                      label={Strings.MIN_AMPLITUDE}
                      checked={!this.state.isAmplitudeCheckboxChecked}
                      value={Constants.MIN_AMPLITUDE_ID}
                      onChange={this.onGraphTypeCheckboxChange} />

                    <Form.Checkbox
                      radio
                      label={Strings.MEAN_AMPLITUDE}
                      checked={this.state.isAmplitudeCheckboxChecked}
                      value={Constants.AMPLITUDE_ID}
                      onChange={this.onGraphTypeCheckboxChange} />
                  </Form.Group>
                </Form>
              </Segment>

              <Segment id="order-seg">
                <Divider horizontal style={dividerStyle}>{Strings.ORDER_BY}</Divider>

                <Form style={formStyle}>
                  <Form.Field style={formFieldStyle}>
                    <Checkbox
                      id="amp-addr-checkbox"
                      radio
                      label={Strings.ADDRESS_ASC}
                      checked={this.state.isAddrCheckboxActive}
                      value={Constants.CHECKBOX_ADDR_VAL}
                      onChange={this.handleOrderCheckboxChange}
                    />
                  </Form.Field>
                  <Form.Field style={formFieldStyle}>
                    <Checkbox
                      id="amp-asc-checkbox"
                      radio
                      label={Strings.AMPLITUDE_ASC}
                      checked={this.state.isAscCheckboxActive}
                      value={Constants.CHECKBOX_ASC_VAL}
                      onChange={this.handleOrderCheckboxChange}
                    />
                  </Form.Field>
                  <Form.Field style={formFieldStyle}>
                    <Checkbox
                      id="amp-desc-checkbox"
                      radio
                      label={Strings.AMPLITUDE_DESC}
                      checked={this.state.isDescCheckboxActive}
                      value={Constants.CHECKBOX_DESC_VAL}
                      onChange={this.handleOrderCheckboxChange}
                    />
                  </Form.Field>
                </Form>

              </Segment>

              <Accordion id="message-list" styled style={accordionStyle}>
                <Accordion.Title
                  style={accordionTitleStyle}
                  active={this.state.accordionIndex === 1}
                  index={1}
                  onClick={this.handleAccordionClick}
                >
                  <Icon name="exclamation triangle" />
                  {Strings.DETECTED_PROBLEMS}
                  <Icon name="dropdown" />
                </Accordion.Title>
                <Accordion.Content active={this.state.accordionIndex === 1}>
                  <div style={accordionListItemsStyle}>
                    <ul style={{ paddingLeft: 0 }}>
                      {this.state.errorMessages.map((message) => (
                        <li key={message}>{message}</li>
                      ))}
                    </ul>
                  </div>
                </Accordion.Content>
              </Accordion>

            </Grid.Column>

            <Grid.Column width={12}>
              <Segment>

                <Chart
                  id="amp-chart"
                  options={this.state.options}
                  series={[{ name: Strings.MIN_AMPLITUDE, data: [] }]}
                  height={UtilsInstance.adjustChartHeight()}
                  type="bar" />

                <Pagination
                  style={paginationStyle}
                  id="pagination"
                  activePage={this.state.activePage}
                  onPageChange={this.handlePageChange}
                  totalPages={this.state.numOfPages} />

              </Segment>

            </Grid.Column>

          </Grid.Row>
        </Grid>

      </div>
    );
  }
}

const screenStyle = {
  marginTop: "4vh",
  marginRight: "2vw",
  marginLeft: "2vw",
  textAlign: "center",
};

const formStyle = {
  marginTop: "-1vh",
  marginLeft: "auto",
  marginRight: "auto",
  marginBottom: "-2vh"
};

const formFieldStyle = {
  marginBottom: "-1vh"
};

const paginationStyle = {
  visibility: "hidden"
};

const dividerStyle = {
  marginTop: "-0.2vh"
};

const accordionStyle = {
  color: "#9F3A38",
  backgroundColor: "#FFF6F6",
  display: "none",
  marginBottom: "2vh",
};

const accordionTitleStyle = {
  color: "#9F3A38",
};

const accordionListItemsStyle = {
  textAlign: "left",
  listStylePosition: "inside",
};

export default withRouter(BarGraph);